import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { useAuth0 } from "../auth/react-auth0-wrapper";

const PrivateRoute = ({ component: Component, path, roles, ...rest }) => {
  const { isAuthenticated, loginWithRedirect, user, activeTenant } = useAuth0();
  const isInRole = user ? user.isInRole(roles, activeTenant) : false;
  useEffect(() => {
    const fn = async () => {
      if (!isAuthenticated || !isInRole) {
        await loginWithRedirect({
          appState: { targetUrl: "/" }
        });
      }
    };
    fn();
  }, [isAuthenticated, loginWithRedirect, path]);

  const render = props =>
    isAuthenticated === true && isInRole === true ? (
      <Component {...props} {...rest} />
    ) : null;

  return <Route path={path} render={render} {...rest} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  roles: PropTypes.arrayOf(PropTypes.string)
};

export default PrivateRoute;
